import { TGlobalSettingBEResponseSchema } from '@onesource/schemas';
import { queryOptions, useQuery } from '@tanstack/react-query';

import axios from '../axios';
import { GLOBAL_SETTINGS_ENTITY } from './entity';

export const getGlobalSettingsQueryKey = () => [GLOBAL_SETTINGS_ENTITY, 'global'];

export const getGlobalSettingsQueryOptions = () =>
  queryOptions<Partial<TGlobalSettingBEResponseSchema>>({
    queryKey: getGlobalSettingsQueryKey(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      // Public on members-api — the /contact page reads the form URL from here for logged-out visitors.
      const res = await axios.get<Partial<TGlobalSettingBEResponseSchema>>(GLOBAL_SETTINGS_ENTITY, { isPublic: true });
      return res.data;
    },
  });

export const useGetGlobalSettingsQuery = () => useQuery(getGlobalSettingsQueryOptions());
